import { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import type { Event } from '@casetrace/shared';
import { metadataEntriesForDisplay } from './event-metadata';

/** Metadata skjules som standard og kan foldes ut ved behov. */
export function EventMetadataSection({ event }: { event: Event }) {
  const [open, setOpen] = useState(false);
  const entries = metadataEntriesForDisplay(event);

  if (entries.length === 0) {
    return null;
  }

  return (
    <div>
      <button
        type="button"
        onClick={() => setOpen((value) => !value)}
        className="flex items-center gap-1 text-[10px] font-semibold uppercase tracking-widest
                   text-text-tertiary transition-colors hover:text-text-secondary"
        aria-expanded={open}
      >
        {open ? <ChevronDown size={11} /> : <ChevronRight size={11} />}
        Metadata ({entries.length})
      </button>

      {open && (
        <dl className="mt-1.5 flex flex-col gap-1">
          {entries.map(([key, value]) => (
            <div key={key} className="flex gap-2 text-xs">
              <dt className="shrink-0 text-text-tertiary">{key}</dt>
              <dd className="truncate text-text-secondary">{String(value)}</dd>
            </div>
          ))}
        </dl>
      )}
    </div>
  );
}
